import { styled, Divider, TableCell, Link } from '@mui/material';
import { IconButton } from '@totalsoft/rocket-ui';

export const ToolbarWrapper = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(-3),
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1)
}));

export const SelectedForManualInterrogationWrapper = styled(IconButton, {
  shouldForwardProp: prop => !['isSelected'].includes(prop)
})(({ isSelected, theme }) => ({
  ...(isSelected && {
    color: theme.palette.info.main,
    stroke: 'currentColor',
    strokeWidth: '0.5'
  })
}));

export const DividerWrapper = styled(Divider)(({ theme }) => ({
  height: theme.spacing(0.5),
  borderRadius: theme.spacing(0.5),
  marginTop: theme.spacing(2),
  background: theme.palette.grey
}));

export const StatusTableCell = styled(TableCell, {
  shouldForwardProp: prop => !['statusCode'].includes(prop)
})(({ statusCode, theme }) => ({
  ...(statusCode === 'ERROR' && {
    color: theme.palette.error.main,
    fontWeight: 'bold'
  }),
  ...(statusCode === 'COMPLETED' && {
    color: theme.palette.success.main,
    fontWeight: 'bold'
  }),
  fontWeight: 'bold'
}));

export const DownloadClickWrapper = styled('span')(({ theme }) => ({
  cursor: 'pointer',
  color: theme.palette.info.main
}));

export const SummaryClickWrapper = styled(Link)(({ theme }) => ({
  cursor: 'pointer',
  color: theme.palette.info.main
}));

export const VerificationTableContainerWrapper = styled('div')(({ theme }) => ({
  width: '100%',
  '@media (max-width: 480px)': {
    overflowX: 'scroll',
    overflowY: 'hidden'
  },
  paddingTop: theme.spacing(1),
  paddingLeft: theme.spacing(3),
  overflowX: 'auto'
}));
